import service from './request'
import md5 from 'js-md5';




//数据共享菜单
export const dataset = data => {
      return service({
            url: '/share/dataset/list',
            method: 'get',
      })
}


//数据共享菜单
export const datasetList = data => {
      var url;
      if (data.datasetType) {
            url = `/share/dataset/metadata/list?${data.datasetType}pageNum=${data.pageNum}&pageSize=${data.pageSize}&sort=${data.sort}`;
      } else {
            url = `/share/dataset/metadata/list?pageNum=${data.pageNum}&pageSize=${data.pageSize}&sort=${data.sort}`;
      }
      return service({
            url: url,
            method: 'get',
            //     data:{
            //       pageNum:data.pageNum,
            //       pageSize:data.pageSize,
            //       ...data.datasetType
            //     }
      })
}

//dataList
export const dataList = data => {
      return service({
            url: `/share/data/list?dataId=${data.id}&pageNum=${data.currentPage}&pageSize=${data.pageSizes}`,
            method: 'get',
      })
}


//数据详情
export const datainfo = data => {
      return service({
            url: `/share/dataset/metadata/${data}`,
            method: 'get',
      })
}


//模糊查询
export const getByPhrase = data => {
      return service({
            url: `/share/dataset/metadata/dataServiceApi?phrase=${data.phrase}&pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
            method: 'get',
      })
}
//模糊查询
export const getByCnName = data => {
      return service({
            url: `/share/dataset/metadata/getByCnName?cnName=${data}`,
            method: 'get',
      })
}


//     数据共享-看过数据的人还看了
export const seenData = data => {
      return service({
            url: `/share/dataset/metadata/seen/${data}`,
            method: 'get',
      })
}


//     数据共享-其他类型
export const otherData = data => {
      return service({
            url: `/share/dataset/metadata/others/${data}`,
            method: 'get',
      })
}


//  预下载
export const downloadExist = data => {
      return service({
            url: `/share/data/exist?dataId=${data.dataId}&productCode=${data.productCode}`,
            method: 'get',
      })
}




// 数据收藏
export const shoppingCart = data => {
      return service({
            url: `/share/shopping-cart`,
            method: 'post',
            data: { ...data }
      })
}


// 数据收藏列表
export const shoppingCartList = data => {
      return service({
            url: `/share/shopping-cart/list?createBy=${data.createBy}&pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
            method: 'get',
      })
}




// 数据分类
export const categories = data => {
      return service({
            url: '/share/dataset/categories?pid=200',
            method: 'get',
      })
}

// 最受欢迎专区
export const likeDataSat = data => {
      return service({
            url: '/share/dataset/metadata/layer',
            method: 'get',
      })
}

// 热门数据排行榜
export const topDataSat = data => {
      return service({
            url: '/share/dataset/metadata/top-data-ranking',
            method: 'get',
      })
}

// 最近更新
export const lastUpdateDataSat = data => {
      return service({
            url: '/share/dataset/metadata/last-update',
            method: 'get',
      })
}

// 分类数据列表
export const typeDataSatList = data => {
      return service({
            url: '/share/dataset/metadata/layer2',
            method: 'get',
      })
}

// 添加到收藏夹
export const Collect = data => {
      return service({
            url: '/share/favorites',
            method: 'post',
            data:{
                  productCode:data.productCode,
                  productName:data.productName,
                  thumbnail:data.thumbnail
            }
      })
}


// 获取元数据大小
export const datasetSzie = data => {
      return service({
            url: '/share/dataset/metadata/stat',
            method: 'get',
      })
}